<template>
  <div v-if="showModuloForm === false">
    <MarketingModules></MarketingModules>
  </div>
  <div class="page" v-else-if="showModuloForm === true">
    <Panel lineColor="var(--primary-color)">
      <template v-slot:options>
        <FormButtonGroup align="end" spaced>
          <FormButton
            text="Saldo de pontos"
            type="auxiliar"
            :disabled="!getFornecedorId"
            @click="abrirSaldoPontos"
          />
          <FormButton
            text="Histórico de movimentação"
            type="auxiliar"
            :disabled="!getFornecedorId"
            @click="abrirHistoricoMovimentacao"
          />
          <FormButton
            text="Editar Regras"
            type="primario"
            :disabled="!getFornecedorId"
            @click="configModalOpen = true"
          />
        </FormButtonGroup>
      </template>
      <DataTable
        :headers="headers"
        :endpoint="endpoint"
        :filters="tableFilters"
        :noHideFilters="true"
        :search="false"
        :autoSearch="false"
        sortBy="created_at"
        :sortDesc="true"
        ref="datatable"
        :itemsPerPage="20"
        @click="onRowClick"
      >
        <template v-slot:coupon_value="{ col }">
          {{ formatMoney(col) }}
        </template>
        <template v-slot:points_used="{ col }">
          {{ formatNumber(col) }}
        </template>
        <template v-slot:status="{ col }">
          <Chip
            v-if="col === 'DISPONIVEL'"
            color="green"
            :small="true"
            text="Disponível"
          />
          <Chip
            v-else-if="col === 'UTILIZADO'"
            color="blue"
            :small="true"
            text="Utilizado"
          />
          <Chip
            v-else-if="col === 'VENCIDO'"
            color="grey"
            :small="true"
            text="Vencido"
          />
          <span v-else>{{ col || "-" }}</span>
        </template>
        <template v-slot:created_at="{ col }">
          {{ formatDateTime(col) }}
        </template>
        <template v-slot:usage_date="{ col }">
          {{ formatDateTime(col) }}
        </template>
        <template v-slot:expiration_date="{ col }">
          {{ formatDateTime(col) }}
        </template>
      </DataTable>
    </Panel>
    <transition name="slide-popup" mode="out-in">
      <router-view class="view" @close="onCloseDetalhe" />
    </transition>
    <ProgramaRecompensaConfigModal
      v-model="configModalOpen"
      :idfornecedor="String(getFornecedorId || '')"
    />
  </div>
</template>

<script>
import DataTable from "@/components/DataTable";
import Panel from "@/components/Panel";
import Chip from "@/components/Chip";
import FormButton from "@/components/form/FormButton";
import FormButtonGroup from "@/components/form/FormButtonGroup";
import ProgramaRecompensaConfigModal from "./ProgramaRecompensaConfigModal";
import { mapGetters } from "vuex";
import * as moment from "moment";
import MarketingModules from "@/components/MarketingModules";
import { ModulesEnum } from "@/store/actions/modulesEnum";

export default {
  name: "ProgramaRecompensa",
  components: {
    DataTable,
    Panel,
    Chip,
    MarketingModules,
    FormButton,
    FormButtonGroup,
    ProgramaRecompensaConfigModal
  },
  data: () => ({
    configModalOpen: false,
    modulosForm: [
      ModulesEnum.WEB_COMMERCE,
      ModulesEnum.COMMERCE_APP,
      ModulesEnum.VENDAMAIS_WEB,
      ModulesEnum.VENDAMAIS_APP
    ],
    tableFilters: [
      {
        label: "Cliente (nome, e-mail, CPF/CNPJ, documento adicional)",
        query: "cliente",
        type: "text",
        default: "",
        cols: "4"
      },
      {
        label: "Código do cupom",
        query: "codigo_cupom",
        type: "text",
        default: ""
      },
      {
        label: "Data criação (início)",
        query: "data_inicio",
        type: "date",
        default: ""
      },
      {
        label: "Data criação (fim)",
        query: "data_fim",
        type: "date",
        default: ""
      },
      {
        label: "Status",
        query: "status",
        type: "select",
        multiple: "true",
        options: [
          { value: "DISPONIVEL", text: "Disponível" },
          { value: "UTILIZADO", text: "Utilizado" },
          { value: "VENCIDO", text: "Vencido" }
        ],
        default: []
      }
    ],
    headers: [
      { text: "Código do cupom", value: "coupon_code" },
      {
        text: "Cliente",
        value: "client_name",
        align: "center",
        sortable: false
      },
      { text: "Valor do cupom", value: "coupon_value", align: "right" },
      { text: "Pontos utilizados", value: "points_used", align: "right" },
      { text: "Data de criação", value: "created_at", align: "center" },
      { text: "Status", value: "status", align: "center" },
      { text: "Data de utilização", value: "usage_date", align: "center" },
      { text: "Data de expiração", value: "expiration_date", align: "center" }
    ]
  }),
  computed: {
    ...mapGetters(["getFornecedorId", "moduloFornecedorAtivo"]),
    showModuloForm() {
      return this.moduloFornecedorAtivo(this.modulosForm);
    },
    endpoint() {
      return `/api/v4/programa-recompensa/cupom/listar/${this.getFornecedorId}`;
    }
  },
  methods: {
    onRowClick(item) {
      if (!item || !item.id) {
        return;
      }
      this.$router.push({
        name: "ProgramaRecompensaDetalhe",
        params: { idcupom: item.id }
      });
    },
    onCloseDetalhe() {
      if (this.$refs.datatable) {
        this.$refs.datatable.reload();
      }
    },
    formatMoney(v) {
      if (v == null || v === "") {
        return "-";
      }
      const n = parseFloat(String(v).replace(",", "."));
      if (Number.isNaN(n)) {
        return v;
      }
      return n.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL"
      });
    },
    formatNumber(v) {
      if (v == null || v === "") {
        return "-";
      }
      return String(v);
    },
    formatDateTime(v) {
      if (v == null || v === "") {
        return "-";
      }
      return moment(v).isValid() ? moment(v).format("DD/MM/YYYY HH:mm") : v;
    },
    abrirSaldoPontos() {
      this.$router.push({
        name: "ProgramaRecompensaSaldoPontos"
      });
    },
    abrirHistoricoMovimentacao() {
      this.$router.push({
        name: "ProgramaRecompensaHistoricoMovimentacao"
      });
    }
  }
};
</script>
